import React, { memo } from 'react';
import { Tooltip } from '@hose/eui';
import { riskTypeMap, riskColorMap, getRiskComponent } from './utils';
import styles from './RiskWarningItem.module.less';
import { Tag } from '@hose/eui';
import { isErrorItem } from './ai-audit-result/utils';
var RiskWarningItem = memo(function (props) {
    var _a, _b;
    var _c = props.risk, risk = _c === void 0 ? {} : _c, _d = props.riskType, riskType = _d === void 0 ? '' : _d, _e = props.riskName, riskName = _e === void 0 ? '' : _e, _f = props.riskStatus, riskStatus = _f === void 0 ? '' : _f, _g = props.riskVersion, riskVersion = _g === void 0 ? 0 : _g, _h = props.children, children = _h === void 0 ? null : _h;
    var name = riskName || risk.controlName;
    var version = riskVersion || risk.controlVersion;
    var type = riskType || risk.type;
    var status = riskStatus || (isErrorItem(risk) ? 'error' : 'warn');
    var classnames = riskColorMap[type][status] || '';
    var componentMap = getRiskComponent();
    if (type === 'costControl' && version) {
        var ruleDetail = (_a = risk === null || risk === void 0 ? void 0 : risk.ruleDetail) !== null && _a !== void 0 ? _a : '';
        if (ruleDetail.indexOf('版本') > -1 || ruleDetail.indexOf('version') > -1) {
            version = 0;
        }
    }
    return (React.createElement("div", { className: styles['risk-warning-item'] + " " + styles[classnames] },
        React.createElement(RiskWarningItemTitle, { riskType: type, riskName: name, riskVersion: version }),
        React.createElement("div", { className: "risk-item-content" }, ((_b = componentMap[type]) === null || _b === void 0 ? void 0 : _b.call(componentMap, risk)) || children)));
});
export default RiskWarningItem;
export var RiskWarningItemTitle = function (props) {
    var riskType = props.riskType, riskName = props.riskName, riskVersion = props.riskVersion;
    return (React.createElement("div", { className: "risk-item-title" },
        React.createElement(Tag, { color: "warning", className: "mr-8", fill: "invert", size: "small" }, riskTypeMap()[riskType]),
        riskName && (React.createElement(Tooltip, { title: riskName },
            React.createElement("span", { className: "risk-name" }, i18n.get(riskName)))),
        riskVersion && riskVersion > 0 ? (React.createElement("span", { className: "risk-version" },
            " ",
            i18n.get("[\u7248\u672C{__k0}]", { __k0: riskVersion }))) : null));
};
